module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_2_back_sp_2ff37283c29e1fc9d885ed7ad46c5bc0.jpg";